export type MigratedCustomPageSlug = 'faq' | 'schedule' | 'story' | 'travel' | 'vip' | 'welcome';
export type CreateEventFeature =
  | 'useWebsiteDesignerV3'
  | 'bypassWebsiteThemeCustomization'
  | 'useStoryAsCustomPage'
  | 'useFaqAsCustomPage'
  | 'useTravelAsCustomPage'
  | 'useVipAsCustomPage'
  | 'useWelcomeAsCustomPage'
  | 'useScheduleAsCustomPage'
  | 'useGuestPageContentRedesign';

export const MIGRATED_PAGE_TO_EVENT_FEATURE_FLAG: Readonly<Record<MigratedCustomPageSlug, CreateEventFeature>> = {
  story: 'useStoryAsCustomPage',
  faq: 'useFaqAsCustomPage',
  travel: 'useTravelAsCustomPage',
  vip: 'useVipAsCustomPage',
  welcome: 'useWelcomeAsCustomPage',
  schedule: 'useScheduleAsCustomPage',
};

const VALID_SLUGS: ReadonlyArray<string> = Object.keys(MIGRATED_PAGE_TO_EVENT_FEATURE_FLAG);

export type MigratedPagesPayloadKey = 'migratedPages' | 'migratedPagesGeneral';

/**
 * Extracts migrated-page event features from a remote flag payload.
 * The payload key differs by event type: `migratedPages` for weddings,
 * `migratedPagesGeneral` for general events.
 */
export const extractMigratedPageFeatures = (payload: unknown, payloadKey: MigratedPagesPayloadKey): ReadonlyArray<CreateEventFeature> => {
  if (!payload || typeof payload !== 'object') return [];

  const pages = (payload as Record<string, unknown>)[payloadKey];
  if (!Array.isArray(pages)) return [];
  if (!pages.every(p => VALID_SLUGS.includes(p))) return [];

  return pages.map(page => MIGRATED_PAGE_TO_EVENT_FEATURE_FLAG[page as MigratedCustomPageSlug]);
};
